(function () {
  'use strict';

  var module = angular.module('uwAgenda.settings.agendasettings');
  module.controller('AgendaSettingsSharedAgendaTableController', [
    '$rootScope',
    '$state',
    'ItemTableService',
    'SharedAgendaService',
    'AuthenticationService',
    'RoleType',
    AgendaSettingsSharedAgendaTypeControllerFn,
  ]);

  /* controller for shared agenda type */
  function AgendaSettingsSharedAgendaTypeControllerFn(
    $rootScope,
    $state,
    ItemTableService,
    SharedAgendaService,
    AuthenticationService,
    RoleType
  ) {
    var vm = this;

    // the service -> here the ItemTableService
    vm.overview = null;

    vm.isRingphoneAdmin = AuthenticationService.isInRole(RoleType.RingfoonAdmin);

    activate();

    // add new row to table
    vm.add = function () {
      var item = vm.overview.add();
      item.active = true;

      // set default values from selected user
      var user = SharedAgendaService.currentUser();
      if (user) {
        item.fK_Agenda = user.agendaId;
        item.fK_User_Initiator = user.id;
        item.agendaOwnerCaption = user.caption; // only for display till entity has been saved
      }
    };

    vm.filter = function (user) {
      filter(user);
    };

    function filter(user) {
      vm.selectedUser = user;

      var sharedAgendas = vm.sharedAgendaDto.sharedAgendas.filter(
        agenda => agenda.userId === user.id
      );

      vm.overview.init(sharedAgendas);
    }

    function initializeSharedAgendaUsers() {
      var currentUser = SharedAgendaService.currentUser();

      const users = vm.sharedAgendaDto.sharedAgendas.map(function (agenda) {
        return { 
          caption: agenda.userCaption,
          id: agenda.userId
        };
      });

      // make sure the current agenda owner is always in the list of users
      users.push({ id: currentUser.id, caption: currentUser.caption });

      const distinctUsers = [...new Map(users.map((u) => [u.id, u])).values()];
      vm.users = distinctUsers;
    }

    function activate() {
      //service
      vm.overview = ItemTableService;
      vm.overview.data.pagination.active = true;
      vm.overview.data.pagination.itemsPerPage = 100;
      
      if (!vm.sharedAgendaDto.isReleasedView) {
          initializeSharedAgendaUsers();
    
          var currentUser = SharedAgendaService.currentUser();
          filter({ id: currentUser.id, caption: currentUser.caption });
      } else {
        vm.overview.init(vm.sharedAgendaDto.sharedAgendas);
      }
    }
  }
})();
